import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "weather-modal__wrapper"
}
const _hoisted_3 = { class: "weather-modal__current-weather current-weather" }
const _hoisted_4 = { class: "current-weather__icon-row" }
const _hoisted_5 = { class: "current-weather__temperature" }
const _hoisted_6 = { class: "weather-modal__weather-details" }
const _hoisted_7 = { class: "weather-modal__icon-data" }
const _hoisted_8 = { class: "weather-modal__icon-data-value" }
const _hoisted_9 = { class: "weather-modal__icon-data" }
const _hoisted_10 = { class: "weather-modal__icon-data-value" }
const _hoisted_11 = { class: "weather-modal__icon-data" }
const _hoisted_12 = { class: "weather-modal__icon-data-value" }
const _hoisted_13 = { class: "weather-modal__icon-data" }
const _hoisted_14 = { class: "weather-modal__icon-data-icon" }
const _hoisted_15 = { class: "weather-modal__icon-data-value" }
const _hoisted_16 = { class: "weather-modal__air-quality" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "weather-modal__text-data-value" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "weather-modal__text-data-value" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "weather-modal__text-data-value" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "weather-modal__text-data-value" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "weather-modal__text-data-value" }
const _hoisted_27 = {
  key: 2,
  class: "weather-modal__no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openWeather.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "weather-modal__description",
          innerHTML: _ctx.openWeather.description
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.openWeather.temperature)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.openWeather && _ctx.openWeather.temperature !== null
              ? _ctx.openWeather.temperature + 'ºC'
              : _ctx.noData), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "weather-modal__icon-data-icon" }, [
                _createElementVNode("i", { class: "icomoon-meteo-humidity" })
              ], -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.openWeather && _ctx.openWeather.humidity !== null
              ? _ctx.openWeather.humidity + '% RH'
              : _ctx.noData), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "weather-modal__icon-data-icon" }, [
                _createElementVNode("i", { class: "icomoon-meteo-pressure" })
              ], -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.openWeather && _ctx.openWeather.pressure !== null
              ? _ctx.openWeather.pressure + ' hPa'
              : _ctx.noData), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "weather-modal__icon-data-icon" }, [
                _createElementVNode("i", { class: "icomoon-meteo-heavy-wind" })
              ], -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.openWeather && _ctx.openWeather.windSpeed !== null
              ? _ctx.openWeather.windSpeed + ' m/s'
              : _ctx.noData), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.openWeather && _ctx.openWeather.windDegrees !== null
                          ? _ctx.directionToIconMapper(_ctx.direction(_ctx.openWeather.windDegrees)) :
                          _ctx.noData)
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.openWeather && _ctx.openWeather.windDegrees !== null
              ? _ctx.direction(_ctx.openWeather.windDegrees)
              : '-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "weather-modal__text-data",
              title: _ctx.paramsTitles.airCO[_ctx.currentLanguageNumber],
              style: _normalizeStyle({ 'background-color': _ctx.AirQualityService.getColor('CO', _ctx.openWeather.co) })
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "weather-modal__text-data-label" }, "CO", -1)),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.openWeather && _ctx.openWeather.co !== null ? _ctx.openWeather.co + ' µg/m³' : _ctx.noData), 1)
            ], 12, _hoisted_17),
            _createElementVNode("div", {
              class: "weather-modal__text-data",
              title: _ctx.paramsTitles.airNO2[_ctx.currentLanguageNumber],
              style: _normalizeStyle({ 'background-color': _ctx.AirQualityService.getColor('NO2', _ctx.openWeather.no2) })
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "weather-modal__text-data-label" }, "NO2", -1)),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.openWeather && _ctx.openWeather.no2 !== null ? _ctx.openWeather.no2 + ' µg/m³' : _ctx.noData), 1)
            ], 12, _hoisted_19),
            _createElementVNode("div", {
              class: "weather-modal__text-data",
              title: _ctx.paramsTitles.airSO2[_ctx.currentLanguageNumber],
              style: _normalizeStyle({ 'background-color': _ctx.AirQualityService.getColor('SO2', _ctx.openWeather.so2) })
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "weather-modal__text-data-label" }, "SO2", -1)),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.openWeather && _ctx.openWeather.so2 !== null ? _ctx.openWeather.so2 + ' µg/m³' : _ctx.noData), 1)
            ], 12, _hoisted_21),
            _createElementVNode("div", {
              class: "weather-modal__text-data",
              title: _ctx.paramsTitles.airPM25[_ctx.currentLanguageNumber],
              style: _normalizeStyle({ 'background-color': _ctx.AirQualityService.getColor('PM2_5', _ctx.openWeather.pm2_5 ) })
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "weather-modal__text-data-label" }, "PM 2.5", -1)),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.openWeather && _ctx.openWeather.pm2_5 !== null
              ? _ctx.openWeather.pm2_5 + ' µg/m³'
              : _ctx.noData), 1)
            ], 12, _hoisted_23),
            _createElementVNode("div", {
              class: "weather-modal__text-data",
              title: _ctx.paramsTitles.airPM10[_ctx.currentLanguageNumber],
              style: _normalizeStyle({ 'background-color': _ctx.AirQualityService.getColor('PM10', _ctx.openWeather.pm10) })
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "weather-modal__text-data-label" }, "PM 10", -1)),
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.openWeather && _ctx.openWeather.pm10 !== null
              ? _ctx.openWeather.pm10 + ' µg/m³'
              : _ctx.noData), 1)
            ], 12, _hoisted_25)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_translated_text_component, { translation: "modal_ow_no_data" })
        ]))
  ]))
}